import React, {Component} from 'react';
import styled from 'styled-components';
import {mixins} from "../../mixins";

const Value = styled.div`
  margin: 0 10px;
`;

const Button = styled.button`
  padding: 5px;
  height: 20px;
  width: 20px;
  box-sizing: content-box;
  font-weight: bold;
  border: none;
  color: ${p => p.theme.cWhite};
  //background-color: ${p => p.theme.cTheme};
  background: none;
  ${mixins.ease()};
  cursor: pointer;
  position: relative;
  outline: none !important;
  span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:before{
    ${mixins.pseudoToBlock()};
    height: 20px;
    width: 20px;
    background-color: ${p => p.theme.cTheme};
    position: absolute;
    ${mixins.ease()};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:hover, &:focus{
    &:before{
      background-color: ${p => p.theme.cThemeActive};
    }
  }
`;

class Counter extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <Button onClick={() => this.props.onSubtract()}><span>-</span></Button>
                <Value>{this.props.children}</Value>
                <Button onClick={() => this.props.onAdd()}><span>+</span></Button>
            </div>
        );
    }
}

export default styled(Counter)`
    display: flex;
    align-items: center;
`;